import React from 'react';

import CYtPlaya from '@components/Youtube';

export const initialModalState = {
	uniModal: false,
	uniModalProps: {},
};

const uniModalSwitch = toggle => ({
	uniModal: toggle,
});

const uniModalFill = modalObj => ({
	uniModalProps: modalObj,
});

// --------------------------------------------------------

export const modalActions = {
	/**
	 * Modal:
	 */
	__uniModalOpen: () => uniModalSwitch(true),
	__uniModalClose: () => uniModalSwitch(false),
	__uniModalFill: (state, val) => uniModalFill(val),
	__submitErrorMsg: (
		_,
		header,
		main = 'Something went wrong',
		ftrBtns = [],
		noDefault
	) => {
		let footer = [
			{
				type: 'close',
				text: 'Okay',
				focus: ftrBtns.length === 0,
			},
		];

		if (Array.isArray(ftrBtns)) {
			if (noDefault) {
				footer = ftrBtns;
			} else {
				footer = [
					...ftrBtns,

					{
						type: 'close',
						text: 'Okay',
						focus: ftrBtns.length === 0,
					},
				];
			}
		}

		const uniModalProps = uniModalFill({
			header,
			main,
			footer,
		});
		const uniModal = uniModalSwitch(true);

		return {
			...uniModalProps,
			...uniModal,
		};
	},
	__youtubeModal: (_, heading, videoId, start) => {
		const uniModalProps = uniModalFill({
			header: heading,
			bodyClassName: 'p-0',
			main: <CYtPlaya vid={videoId} cinema start={start} />,
			wide: true,
		});
		const uniModal = uniModalSwitch(true);

		return {
			...uniModalProps,
			...uniModal,
		};
	},
	/**
	 * Open Switch Market Modal:
	 */

	__switchMarketModalOpen: (_, coin = 'btc', market_id = -1) => ({
		switchMarketModal: true,
		switchMarketCoin: {
			coin,
			market_id,
		},
	}),
	__switchMarketModalClose: () => ({
		switchMarketModal: false,
	}),
};
